import React, { useState } from "react";
import ImageWithBasePath from "../imageWithBasePath";
import axios from "axios";
import { useAuth } from "../../../feature-module/auth/AuthProvider";
import { t } from "../../../lang/index";

const RegisterModal = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const BASE_URL = process.env.REACT_APP_API_URL;

  const { refreshUserData } = useAuth();

  const sendCode = async () => {
    try {
      await axios.post(`${BASE_URL}/teste/gerar-codigo-manual`, null, {
        params: { email, codigo: "123456" },
      });
      setMessage(t("auth.registerModal.testCodeSuccess"));
      setError("");
      setStep(2);
    } catch {
      setError(t("auth.registerModal.testCodeError"));
      setMessage("");
    }
  };

  const sendCodeEmail = async () => {
    try {
      await axios.post(`${BASE_URL}/auth/enviar-codigo`, { email });
      setMessage(t("auth.registerModal.emailSent"));
      setError("");
      setStep(2);
    } catch {
      setError(t("auth.registerModal.emailError"));
      setMessage("");
    }
  };

  const verifyCode = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/auth/verificar-codigo`, {
        email,
        codigo: code,
      });

      const token = response.data.token;
      localStorage.setItem("token", token);
      await refreshUserData();

      setMessage(t("auth.registerModal.loginSuccess"));
      setError("");

      const modal = document.getElementById("register-modal");
      let bootstrapModal = (window as any).bootstrap?.Modal.getInstance(modal);
      if (!bootstrapModal) {
        bootstrapModal = new (window as any).bootstrap.Modal(modal);
      }
      bootstrapModal.hide();

      setTimeout(() => {
        document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
        document.body.classList.remove("modal-open");

        const reminderModalEl = document.getElementById("profile-reminder-modal");
        if (reminderModalEl) {
          const reminderModal = new (window as any).bootstrap.Modal(reminderModalEl);
          reminderModal.show();
        }
      }, 400);
    } catch {
      setError(t("auth.registerModal.invalidCode"));
      setMessage("");
    }
  };

  const getOAuth2Url = (provider: "google" | "facebook") => {
    const base = BASE_URL?.replace(/\/api$/, "") ?? "";
    return `${base}/oauth2/authorization/${provider}`;
  };

  return (
    <>
      {/* Register Modal */}
      <div className="modal fade" id="register-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body p-4 pt-0">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="text-center border-bottom mb-3">
                  <h5 className="mb-1">{t("auth.registerModal.title")}</h5>
                  <p className="mb-3">{t("auth.registerModal.subtitle")}</p>
                </div>

                {step === 1 && (
                  <div className="mb-3">
                    <label className="form-label">{t("auth.registerModal.emailLabel")}</label>
                    <div className="input-icon">
                      <span className="input-icon-addon">
                        <i className="isax isax-message" />
                      </span>
                      <input
                        type="email"
                        className="form-control form-control-lg"
                        placeholder={t("auth.registerModal.emailPlaceholder")}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    <button type="button" onClick={sendCode} className="btn btn-secondary mt-3 w-100">
                      {t("auth.registerModal.sendTestCode")}
                    </button>

                    <button type="button" onClick={sendCodeEmail} className="btn btn-primary mt-2 w-100">
                      {t("auth.registerModal.sendEmailCode")}
                    </button>
                  </div>
                )}

                {step === 2 && (
                  <div className="mb-3">
                    <label className="form-label">{t("auth.registerModal.codeLabel")}</label>
                    <div className="input-icon">
                      <span className="input-icon-addon">
                        <i className="isax isax-key" />
                      </span>
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder={t("auth.registerModal.codePlaceholder")}
                        value={code}
                        onChange={(e) => setCode(e.target.value.toUpperCase())}
                        style={{ textTransform: "uppercase" }}
                      />
                    </div>
                    <button onClick={verifyCode} className="btn btn-success mt-3 w-100">
                      {t("auth.registerModal.verifyAndLogin")}
                    </button>
                  </div>
                )}

                {message && <div className="alert alert-success mt-2">{message}</div>}
                {error && <div className="alert alert-danger mt-2">{error}</div>}

                <div className="login-or my-3">
                  <span className="span-or">{t("auth.registerModal.or")}</span>
                </div>

                <div className="d-flex align-items-center mb-3">
                  <a
                    href={getOAuth2Url("google")}
                    className="btn btn-light flex-fill d-flex align-items-center justify-content-center me-2"
                  >
                    <ImageWithBasePath src="assets/img/icons/google-icon.svg" className="me-2" alt="Google" />
                    {t("auth.registerModal.google")}
                  </a>
                  <a
                    href={getOAuth2Url("facebook")}
                    className="btn btn-light flex-fill d-flex align-items-center justify-content-center"
                  >
                    <ImageWithBasePath src="assets/img/icons/fb-icon.svg" className="me-2" alt="Facebook" />
                    {t("auth.registerModal.facebook")}
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Reminder Modal */}
      <div className="modal fade" id="profile-reminder-modal" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{t("auth.registerModal.reminderTitle")}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              <p>{t("auth.registerModal.reminderText")}</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" data-bs-dismiss="modal">
                {t("auth.registerModal.gotIt")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterModal;